import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import TextField from '@ui-lib/components/Inputs/TextField/FormikTextField';
import LocationSelect from './components/LocationSelect';

export const Step1 = (() => {

  const { t } = useTranslation();

  return (
    <Stack>
      <Typography variant="subtitle1Bold" gutterBottom>
        {t('stepTitle_shipmentDetails')}
      </Typography>

      <TextField
        required
        name="reference_number"
        label={t('referenceNumber')}
      />

      <LocationSelect />

    </Stack>
  );
});
